var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 180,
    viewBox: "0 0 181 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 24C0.5 10.7452 11.2452 0 24.5 0H156.5C169.755 0 180.5 10.7452 180.5 24V156C180.5 169.255 169.755 180 156.5 180H24.5C11.2452 180 0.5 169.255 0.5 156V24Z",
    fill: "#272860"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103.576 23.625H76.8712L49.4375 96.75H73.9167L85.0151 65.66L89.5227 50.5513H90.9148L95.4223 65.66L106.521 96.75H131L103.576 23.625Z",
    fill: "#67BE68"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0561 106.838L26.6562 161.151H54.084L64.9525 129.661H115.766L126.635 161.151H154.062L133.663 106.838H47.0561Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.076b941bfb01a4332979068ba05966b1.svg";
export { ForwardRef as ReactComponent };